import React from 'react';
import SelectBase from './SelectBase';
import { DownArrow, ClearIcon } from './SelectInput';
import { renderSelectItems } from './SelectItem';

const caseInsensitiveIncludes = (strA = '', strB = '') => strA.toUpperCase().includes(strB.toUpperCase());

const filterOptions = ({ inputValue }) => (item) => !inputValue || caseInsensitiveIncludes(item.label, inputValue);

const isItemSelected = (item, selectedItem) => selectedItem && item.value === selectedItem.value;

const renderOptions = renderSelectItems(isItemSelected);

const clearInputValue = (e, { setState }) => {
	setState({
		inputValue: ''
	});
};

const renderInputDecoration = (disabled,inputRef) => ({ selectedItem, clearSelection }) =>
	!selectedItem || disabled ? (
		<DownArrow disabled={disabled} />
	) : (
		<span onClick={clearSelection} ref={inputRef}>
			<ClearIcon />
		</span>
	);

//TODO: Should be able to remove the "or" item.label || item
//once all options are guaranteed to be Optionables
const selectedItemToString = (item) => (!item ? '' : item.label || item);

const SingleSelect = ({ label, placeholder, options, initialValue, disabled, onChange, onBlur,inputRef, ...rest }) => {
	return (
		<SelectBase
			label={label}
			options={options}
			placeholder={placeholder}
			initialValue={initialValue || ''}
			selectedItemToString={selectedItemToString}
			noResultsText="No results found"
			disabled={disabled}
			onChange={(changes) => {
				const value = changes ? changes.value : '';
				onChange && onChange(value);
			}}
			onBlur={onBlur}
			onInputClick={clearInputValue}
			filterOptions={filterOptions}
			renderOption={renderOptions}
			renderInputDecoration={renderInputDecoration(disabled,inputRef)}
			{...rest}
		/>
	);
};

export default SingleSelect;
